import { useEffect, useState } from 'react';
export const useHasScrolled = (distance) => {
    const [hasScrolled, setHasScrolled] = useState(false);
    useEffect(() => {
        const scrollHandler = () => {
            setHasScrolled(global.scrollY > distance);
        };
        scrollHandler();
        document.addEventListener('scroll', scrollHandler);
        return () => {
            document.removeEventListener('scroll', scrollHandler);
        };
    }, []);
    return hasScrolled;
};
//# sourceMappingURL=use-has-scrolled.js.map